import { Flex, FormControl, FormLabel } from "@chakra-ui/react";
import { FileUpload } from "../base/file-upload/file-upload.comp";
import { useState } from "react";
import { adminActionService } from "../../services";

export const ObfuscateDataTab = () => {
    const [selectedBoB, setSelectedBoB] = useState<File>();
    const [selectedCommSheet, setSelectedCommSheet] = useState<File>();

    const download = (blob: Blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "obfuscated-file.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
    };

    const onSubmitBoB = async () => {
        if (selectedBoB) {
            const blob = await adminActionService.obfuscateUHCBoB(selectedBoB);
            download(blob);
        }
    };

    const onSubmitCommSheet = async () => {
        if (selectedCommSheet) {
            const blob = await adminActionService.obfuscateUHCCommSheet(selectedCommSheet);
            download(blob);
        }
    };

    return (
        <Flex>
            <FormControl>
                <FormLabel>UHC Book of Business</FormLabel>
                <FileUpload
                    onCancel={() => setSelectedBoB(undefined)}
                    onSelectFile={(f) => setSelectedBoB(f)}
                    handleSubmit={onSubmitBoB}
                    file={selectedBoB}
                />
            </FormControl>
            <FormControl>
                <FormLabel>UHC Commission Sheet</FormLabel>
                <FileUpload
                    onCancel={() => setSelectedCommSheet(undefined)}
                    onSelectFile={(f) => setSelectedCommSheet(f)}
                    handleSubmit={onSubmitCommSheet}
                    file={selectedCommSheet}
                />
            </FormControl>
        </Flex>
    )
};